import { render } from "./CustomColumnTemplate.vue?vue&type=template&id=69337ec8"
import script from "./CustomColumnTemplate.vue?vue&type=script&lang=js"
export * from "./CustomColumnTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script